var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-grid p-fluid p-justify-center"},[_c('div',{staticClass:"p-col-12",staticStyle:{"max-width":"460px"}},[_c('Header',{staticStyle:{"margin":"2em 0"}}),_vm._t("default"),_c('Footer',{staticStyle:{"margin-top":"4em"}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }